<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.listaAdmini')}} </h4>
        </div>
        <div class="page-header-inner" v-if="$can(['create admin'])">
            <div class="table-header">
                <div class="search-box">
                    <button type="button" class="template-button" @click="$router.push('/admins/create')">
                        <i class="fas fa-plus-circle"></i> {{$t('txt.adaugaAdmin')}}
                    </button>
                </div>
            </div>
        </div>
        <table class="table app_table">
            <thead>
            <tr class="app_table_header">
                <th scope="col"> {{$t('tableHeader.nume')}}</th>
                <th scope="col"> {{$t('tableHeader.prenume')}}</th>
                <th scope="col" class="mobilehidden_header"> {{$t('tableHeader.email')}}</th>
                <th scope="col"> {{$t('tableHeader.telefon')}}</th>
                <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
            </tr>
            </thead>
            <tbody v-if="admins">
                <tr v-for="(admin, index) in admins" :key="index" @dblclick="$router.push({ name: 'viewadmin', params: { id: admin.id }})" @keyup="$router.push({ name: 'viewadmin', params: { id: admin.id }})">
                    <td :tableheadData="$t('tableHeader.nume')"> {{(admin.first_name) ? admin.first_name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.prenume')"> {{(admin.last_name) ? admin.last_name : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.email')" class="mobilehidden_header"> {{(admin.email) ? admin.email: '-'}}</td>
                    <td :tableheadData="$t('tableHeader.telefon')"> {{(admin.phone) ? admin.phone : '-'}}</td>
                    <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                        <router-link :to="{ name: 'viewadmin', params: { id: admin.id }}" class="view-user" v-if="$can(['view admin'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                            <i class="fas fa-eye"></i>
                        </router-link>
                        <router-link :to="{ name: 'editadmin', params: { id: admin.id }}" class="edit-user" v-if="$can(['update admin'])"
                                     data-placement="top" data-toggle="tooltip" :title="$t('placeholder.editeaza')">
                            <i class="fas fa-pen"></i>
                        </router-link>
                        <a href="javascript:void(0)" class="delete-user" data-placement="top" data-toggle="tooltip" v-if="$can(['delete admin'])"
                           :title="$t('placeholder.sterge')" @click="removeUser(index, admin.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                    <td colspan="5" v-else>{{$t('errors.emptyResult')}}</td>
                </tr>
            </tbody>
            <tfoot v-if="admins">
            <tr class="app_table_header">
                <th scope="col">
                    {{$t('tableHeader.nume')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.prenume')}}
                </th>
                <th scope="col" class="mobilehidden_header">
                    {{$t('tableHeader.email')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.telefon')}}
                </th>
                <th scope="col">
                    {{$t('tableHeader.optiuni')}}
                </th>
            </tr>
            </tfoot>
        </table>
        <div class="col-lg-12 col-md-12" v-if="admins">
            <div class="pagination-wrapper">
                <div class="results-message">
                    <p>
                        <i class="fas fa-info-circle"></i>
                        {{$t('pagination.info', { from: this.meta.from, to: this.meta.to, total: this.meta.total })}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminsService from '../../api-services/admins.service.js'
export default {
  name: 'admins',
  data () {
    return {
      admins: []
    }
  },
  methods: {
    getAdmins () {
      this.admins = null
      this.$store.dispatch('showLoading')
      AdminsService.getAll()
        .then((response) => {
          if (response.data.data.length > 0) {
            this.admins = response.data.data
          } else {
            this.admins = null
          }
          this.meta = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          let message = error.response.data.error
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: message,
            'animation-type': 'css'
          })
          this.$store.dispatch('hideLoading')
        })
    },
    removeUser (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeAdmin'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          AdminsService.delete(id)
            .then((response) => {
              this.$delete(this.admins, index)
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  created () {
    this.getAdmins()
  }
}
</script>
